{
  "update-password-pin-dialog": {
    "buttons": {
      "resend": "Renvoyer",
      "submit": "Soumettre"
    },
    "text": {
      "enter-pin": "Veuillez saisir le code PIN pour confirmer votre nouveau mot de passe.",
      "in-second": "en {{seconds}} s",
      "password-updated": "Le mot de passe a été mis à jour avec succès !",
      "pin-via-email": "Le code PIN est envoyé à votre e-mail",
      "pin-via-sms": "Le code PIN est envoyé à votre numéro de téléphone",
      "update-password": "Mise à jour du mot de passe"
    }
  }
}
